import React from 'react';
import { View, Text } from 'react-native';
import DocketItemStyles from '../DocketItem.styles';
import { useColors } from '../../../hooks/useColors';
import Icon from '../../Icon/Icon';

export interface DocketAllergenBannerProps {
  name: string;
}

const DocketAllergenBanner: React.FC<DocketAllergenBannerProps> = ({
  name,
}) => {
  const styles = DocketItemStyles();
  const { colors } = useColors();

  return (
    <View testID="allergen-banner" style={styles.allergenBanner}>
      <Icon
        size={20}
        name="exclamation-triangle"
        color={colors.allergenBannerText}
      />
      <Text style={styles.allergenBannerText}>{name}</Text>
    </View>
  );
};

export default DocketAllergenBanner;
